import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 55"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M38.405 35.147v-.394h.16v-.081h-.404v.081h.16v.394h.088-.004Zm.785 0v-.475h-.122l-.143.326-.143-.326h-.122v.475h.088v-.357l.133.31h.091l.133-.31v.36h.088l-.003-.003Zm-20.487 2.36c.095.082.197.164.296.245a12.178 12.178 0 0 1-6.77 2.045C5.476 39.797 0 34.322 0 27.57s5.476-12.23 12.229-12.23c2.503 0 4.83.755 6.77 2.046-.099.081-.2.16-.296.244a13.18 13.18 0 0 0-4.535 9.94c0 3.808 1.651 7.432 4.535 9.939Zm8.642-22.167c-2.504 0-4.83.754-6.77 2.045.098.081.2.16.296.244a13.175 13.175 0 0 1 4.534 9.94c0 3.81-1.65 7.432-4.531 9.939-.095.081-.197.163-.296.244a12.178 12.178 0 0 0 6.77 2.045c6.753 0 12.23-5.475 12.23-12.228s-5.48-12.23-12.233-12.23Zm-7.558 2.619a12.193 12.193 0 0 0-4.67 9.61c0 3.682 1.63 6.984 4.208 9.226.15.132.306.258.462.383a12.194 12.194 0 0 0 4.67-9.61c0-3.682-1.63-6.983-4.208-9.225-.15-.133-.306-.259-.462-.384Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "mastercard"}) } }